module.exports = __webpack_public_path__ + "glyphicons-social-regular.8e9e5a3b5da434082059.svg";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.svg
// module id = ../../../../../src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.svg
// module chunks = 2